import { Card, Avatar, Typography, Badge, Space, Divider } from "antd";
import { StarFilled, MessageOutlined, TeamOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

export function DoctorProfile() {
  return (
    <Card className=" h-full">
      <div className="flex gap-4">
        <Avatar size={64} src="/professional-doctor-portrait.png" className="flex-shrink-0">
          NK
        </Avatar>
        <div className="flex-1">
          <div className="flex justify-between items-start">
            <Title level={4} className="m-0">Dr. Neelesh Kapoor</Title>
            <Badge count="Connect on the App" className="bg-gray-100 text-black text-xs" />
          </div>
          <Text type="secondary" className="block mt-1 text-sm font-bold text-gray-900">Senior Consultant Physician And Diabetologist in Ghaziabad</Text>
          <Text type="secondary" className="block mt-2 text-sm font-medium text-gray-900 leading-relaxed">
            MBBS, MD - General Medicine, DM - Endocrinology. Dr. Neelesh Kapoor is a renowned physician specializing
            in diabetes management and other medical ailments. He provides excellent care and treatment to his patients.
          </Text>
          <Space className="mt-4">
            <Badge color="green" text={
              <Space>
                <MessageOutlined />
                VIDEO CONSULTATION
              </Space>
            } />
            <Badge color="blue" text={
              <Space>
                <TeamOutlined />
                IN-CLINIC VISITS
              </Space>
            } />
          </Space>
        </div>
      </div>

      <Divider className="my-4" />

      <div className="flex justify-between items-center">
        <Space>
          <StarFilled className="text-yellow-400" />
          <Text strong>4.9</Text>
          <Text type="secondary">19 Yrs</Text>
        </Space>
        <Space size={4}>
          <Text type="secondary">English</Text>
          <Text type="secondary">|</Text>
          <Text type="secondary">हिंदी</Text>
        </Space>
      </div>

      <Divider className="my-4" />

      <div>
        <Title level={5}>ABOUT THE DOCTOR</Title>
        <Text type="secondary" className="text-sm font-medium text-gray-900 leading-relaxed">
          Dr. Neelesh Kapoor is a highly experienced physician with over 19 years of practice in General Medicine and
          Diabetology. He specializes in managing diabetes, hypertension, and other chronic conditions. Dr. Kapoor is
          known for his patient-centric approach and evidence-based treatment methods.
        </Text>
      </div>
    </Card>
  );
}
